module.exports = __webpack_public_path__ + "img/whatsapp.953a8c3e.png";